import { FormGroup, ValidationErrors } from "@angular/forms";
//import { UploadFileService } from "../../sevices/upload-file/uploadfile.service";

export class formMange {

    public form: FormGroup;
    public file;
    constructor() {
    }
    setForm(form) {
        this.form = form;
    }
    markAllFeildsTouched() {
        Object.keys(this.form.controls).forEach(key => {
            this.form.controls[key].markAsTouched()
        });
    }

    isFieldValid(ControlName) {
        return this.form.controls[ControlName].touched && this.form.controls[ControlName].invalid

    }
    setContollerValue(name: string, value: any) {
        this.form.controls[name].setValue(value)
    }
    getFormValidationErrors() {
        Object.keys(this.form.controls).forEach(key => {

            const controlErrors: ValidationErrors = this.form.get(key).errors;
            if (controlErrors != null) {
                Object.keys(controlErrors).forEach(keyError => {
                    console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
                });
            }
        });
    }
    get isFormValid() {
        this.markAllFeildsTouched()
        return this.form.valid;
    }
    get FormValue() {
        return this.form.value;
    }
    resetForm() {
        this.form.reset()
    }
    setFormErrors(errors) {
        Object.keys(errors).forEach(error => {
            if (this.form.controls[error]) {
                this.form.controls[error].setErrors({ 'incorrect': true })
            }
        })
    }
}